import { render } from "./VolunteerInviteCard.vue?vue&type=template&id=091fa64c&scoped=true"
import script from "./VolunteerInviteCard.vue?vue&type=script&lang=js"
export * from "./VolunteerInviteCard.vue?vue&type=script&lang=js"

import "./VolunteerInviteCard.vue?vue&type=style&index=0&id=091fa64c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091fa64c"]])

export default __exports__